import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';

import { IconType } from 'react-icons/lib';

import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';

import { usePages } from '../../hooks/Pages';
import { useLanguage } from '../../hooks/Language';
import SlideList from '../DashboardPages/features/SliderComponent';
import ProjectList from '../DashboardPages/features/ProjectList';
import EventList from '../DashboardPages/features/EventsList';
import api from '../../services/api';
import { hash, urlWebsite } from '../../config';
import { Button } from '../../components/Button/styles';
import SliderContainer from '../../components/SliderContainer';
import { FaBrain, FaSearch, FaStar } from 'react-icons/fa';
import Calendar from './modules/Calendar';
import SelectSimple from '../../components/Forms/SelectSimple';
import EventsListDisplay from '../DashboardPages/features/EventsListDisplay';
import PosterListDisplay from '../DashboardPages/features/PosterListDisplay';
import TestimonialListDisplay from '../DashboardPages/features/TestimonialDisplay';
import { ContactIcons, ContactIconsOrange, scrollTo } from '../../components/Menu';
import themeDefault from '../../styles/ThemeComponents';
import Input from '../../components/Forms/Input';
import SignUp from '../SignUp';
import Youtube from '../../components/Youtube';
import ContagemRegressiva from '../../components/ContagemRegressiva';
import { loadFromJson } from '../../utils/loadFromJson';
import Speakers from '../Speakers';
import Program from '../Program';
import { useConfiguration } from '../../hooks/Configuration';
import Cronograma from '../Cronograma';
import News from '../News';
import ProgramTable from '../ProgramTable';


interface IMenu {
  title: string;
  target: string;
  targetID: string;
  fluid: number;
  external: number;
  status: number;
}

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Home2: React.FC = () => {

  const { setMenu } = usePages();
  const { setAvailableLanguages } = useLanguage();
  const { translate } = useLanguage();
  const { addModal, removeModal } = useModal();
  const [slides, setSlides] = useState<Array<JSX.Element>>([]);
  const { user } = useAuth();
  const { configuration } = useConfiguration();
  const [search, setSearch] = useState('');
  const [currentCategory, setCurrentCategory] = useState('');
  const sendToEvents = () => {

    let link = currentCategory ? `/eventos/${currentCategory}` : `/eventos`;

    if (search) {
      link = `${link}?search=${encodeURIComponent(search)}`;
    }

    window.location.href = link;

  }

  const loadConfig = async () => {
    let data: Record<string, any> = {};

    const item = await loadFromJson({ hash: hash, project_id: 'global', table: 'Global' })


    if (!item) {
      const config = await api.get('/get_platform');

      data = config.data;
    }
    else {
      data = item?.[0] || {}
    }


    if (data.slides) {
      const slideJSX: Array<JSX.Element> = [];

      data.slides.map(s => {
        slideJSX.push(s.link_url ? <a href={s.link_url}><img src={`${urlWebsite}/${s.url}`} style={{ width: '100%' }} /></a> : <img src={`${urlWebsite}/${s.url}`} style={{ width: '100%' }} />)
      })

      setSlides(slideJSX);

      if (data?.popup_status === 'yes' && data?.popup_images && data?.popup_images?.length > 0) {

        if (user && user.updated_information !== 'yes' && user.profile === 2) {

        }
        else {
          addModal({
            key: 'popup',
            theme: 'whiteModalCapa',
            title: ' ',
            content: <><div style={{ width: '100%', maxWidth: '700px', margin: '0px auto' }}>
              {data?.popup_images.map(popup => {
                return popup?.link_url ? <a onClick={() => removeModal('popup')} key={`popup-url-${popup.url}`} style={{ width: '100%', maxWidth: '700px', margin: '15px auto' }} href={`${popup?.link_url}`}>
                  <img src={`${urlWebsite}/${popup.url}`} style={{ width: '100%', maxWidth: '500px', margin: '0px auto' }} />
                </a> : <img src={`${urlWebsite}/${popup.url}`} style={{ width: '100%', maxWidth: '500px', margin: '0px auto' }} />


              })}

            </div></>
          })

        }


      }

    }

    const menu: Array<IMenu> = [];

    try {
      data?.menu.map((m: IMenu) => {
        m.fluid = parseInt(m.fluid.toString(), 10);
        m.status = parseInt(m.status.toString(), 10);
        m.external = parseInt(m.external.toString(), 10);

        menu.push(m);
      })

      setMenu(menu);

    }
    catch (err) {
      console.log('Error on define Menu');
    }


    setAvailableLanguages(data?.languages || []);




  }

  useEffect(() => {
    loadConfig();
    /*
        addModal({
       key:'popup',
       theme: 'whiteModal2',
       title:' ',
       content: <><div style={{width:'100%', maxWidth:'500px', margin: '0px auto'}}>
         <Link onClick={() => removeModal('popup')} style={{width:'100%', maxWidth:'500px', margin: '0px auto'}} to="/app/sessao-clinica-hospitais-dasa-brasil/login">
           <img src="/apoio/sessao-clinica.png" style={{width:'100%', maxWidth:'500px', margin: '0px auto'}}/>
         </Link>
         </div></>
     }  ) */
  }, [])

  const confirmPresense = (data) => {

  }


  const handle = () => { }

  return (<>
    <Container className='bg1' style={{ minHeight: '80vh' }}  >
      <Capa  >
        <div className=' '>
          <div className='singleLogos'  >
            <img src="/assets/logo.jpeg" style={{ width: '100%', maxWidth: '800px' }} />
          </div>


        </div>
        <div className='p50 homeTitle'>








          <p className='subtitle'> <strong  >  14 e 15 de novembro  de 2025</strong> </p>
          <p className='subtitle'> <strong  >  Hospital de Clínicas de Porto Alegre</strong> </p>
          <p className='subtitle'><strong >Evento presencial</strong><br />

            <br />
          </p>
          {/*   <Link to={`/quero-ser-avaliador`} className="buttonBigBlue" style={{ margin: '5px 0px' }}><button style={{ margin: '0px' }}>QUERO SER AVALIADOR</button></Link>
          <Link to={`/quero-ser-monitor`} className="buttonBigBlue" style={{ margin: '5px 0px' }}><button style={{ margin: '0px' }}>QUERO SER MONITOR</button></Link>
  */}
          {configuration?.active_pages && configuration?.active_pages?.map(button => {

            return button?.active === 'yes' ? <a href={button?.type === 'external' ? button?.url : `/app/${configuration?.url}/${button?.url}`} onClick={(e) => {
              if (button.type === 'page') {
                e.preventDefault();
                scrollTo(e, button.url, 200);


              }
            }} className="buttonBigBlue" style={{ margin: '5px 0px' }}><button style={{ margin: '0px' }} >{button?.title?.toUpperCase()}</button></a> : <></>
          }

          )}


          <a href={`/apoio/normas-36-simposio-de-oftalmologia-do-hcpa.pdf`} download className="buttonBigBlue" style={{ margin: '5px 0px' }}><button style={{ margin: '0px' }}>VISUALIZAR EDITAL DE SUBMISSÃO</button></a>

      

          <ContagemRegressiva />
        </div>





      </Capa>




    </Container>
    {/* <Container className='bg2  noPadding noMax' style={{ minHeight: 'auto', background: 'rgba(255,255,255,0.95' }}>
      <Capa className=' noPadding noMax' style={{ marginBottom: '25px', }}>


        <div className='p50 homeTitle'>




          <h2  >A conversa sobre saúde no trabalho não pode parar</h2>



          <p className='description'>Em sua terceira edição, o 36º Simpósio de Oftalmologia do HCPA Saúde 2023 vem aí! O mais completo evento do Brasil acontecerá nos dias <strong>9 e 10 de maio</strong> em formato híbrido.
            <br /><br />


            Este ano, especialistas falarão sobre saúde mental, promoção da saúde, segurança e saúde no trabalho, trazendo <strong>reflexões conectadas ao ESG</strong>, uma das temáticas mais importantes da atualidade.

            <br /><br />

            Promovido pelo Serviço Social da Indústria do RS, o 36º Simpósio de Oftalmologia do HCPA Saúde prepara <strong>pessoas e empresas</strong> para uma gestão adequada e avançada da <strong>saúde integral no trabalho</strong>, apresentando formas de promover <strong>ambientes laborais saudáveis</strong> em cenários de constantes mudanças.
          </p>
          <div style={{ width: '100%', maxWidth: '612px', display: 'flex', justifyContent: 'flex-start' }}>
            <a href="/app/simposio/inscricao" className="buttonBigBlue"><button>INSCREVA-SE</button></a>
          </div>



        </div>




      </Capa>

        </Container> */}
    {/*   <div id="programacao" />
    <div className='speakersDivContainer noPadding computerOnly' style={{ width: '100%', background: '#fff', margin: '0px auto', marginBottom: '50px' }}>
      <ProgramTable />
    </div>
    <div className='speakersDivContainer noPadding mobileOnly' style={{ width: '100%', background: '#fff', margin: '0px auto', marginBottom: '50px' }}>
      <Program />
      </div> */}
    <div className='speakersDivContainer noPadding' style={{ width: '100%', background: '#fff', margin: '0px auto', marginBottom: '50px' }}>

      <Cronograma />
    </div>
    { /* <div className='speakersDivContainer noPadding' style={{ width: '100%', background: '#fff', margin: '0px auto', marginBottom: '50px' }}>

      <News />
    </div> */}
    {/* <Container className='bg2  noPadding noMax' style={{ minHeight: 'auto' }}>
      <Capa className=' noPadding noMax' style={{ marginBottom: '25px', flexDirection: 'column' }}>

        <div className='speakersDivContainer noPadding' style={{ width: '100%', maxWidth: '1000px', margin: '10px auto' }}>
          <Speakers background={"none"} />
        </div>



      </Capa>

        </Container> */}


  </>
  );
};
export default Home2;
